import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import moment from 'moment';

import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import { collection, getDocs, query, where } from '@firebase/firestore/lite';

import { getUserName, countDecimals } from '../../services/common-query';
import { bucketlink1 } from '../../config/fire-conf';
import { firebaseFireStore } from '../../config/firebaseFirestore';

const useStyles = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));

export default function OwnerComponent(props) {
  const classes = useStyles();

  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const { ele } = props;
  const [ownerName, setownerName] = useState('');
  const [isMinter, setIsMinter] = useState(false);

  useEffect(() => {
    getMinter();
  }, []);

  useEffect(() => {
    if (ele.userId) {
      getNameFromId();
    }
  }, [ele]);

  const getNameFromId = async () => {
    let lname = await getUserName(ele.userId);
    if (lname) {
      setownerName(lname);
    } else {
      setownerName('unknown');
    }
  };

  const getMinter = async () => {
    const dataQuery = query(
      collection(firebaseFireStore, 'musicartMinters'),
      where('minterId', '==', ele.userId),
    );

    const dataRef = await getDocs(dataQuery);

    if (!dataRef.empty) {
      setIsMinter(true);
      return;
    } else {
      setIsMinter(false);
    }
  };

  return (
    <div
      className="asset__author"
      style={{
        marginBottom: 10,
      }}
      key={props.index + 'ownertab'}
    >
      <div>
        <div
          className={`asset__author ${
            isMinter ? 'asset__author--verified' : ''
          }`}
        >
          <img
            style={{ minWidth: 44, minHeight: 44 }}
            src={
              ele && ele.userId
                ? ele?.userId &&
                  bucketlink1 +
                    'profile_images%2F' +
                    ele.userId +
                    '_250x250?alt=media'
                : '/img/avatars/avatar.jpg'
            }
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/img/avatars/avatar.jpg';
            }}
            alt="owner image"
          />
        </div>
      </div>
      <div className="w-1/2">
        <p className="nftbuyers">
          {(() => {
            if (
              ele.adminState &&
              ele.adminState === 'ACCEPT' &&
              ele.activeInMarketPlace &&
              ele.nftSaleType === 'Auctioning' &&
              ele.auctionStartTime &&
              Number(ele.auctionStartTime) >= Number(moment().format('x'))
            ) {
              return (
                <Link
                  prefetch={false}
                  href={`/nft/${props.nftData.tokenId + '/' + ele.nftId}`}
                >
                  <a>
                    <>
                      {`No ${ele.index}/${
                        props.alllength
                      } On auction, starting at ${
                        ele?.minBiddingPrice ? (
                          <span>
                            <Tooltip title="USD" classes={classes}>
                              <span className="relative">$</span>
                            </Tooltip>
                          </span>
                        ) : (
                          ''
                        )
                      } ${ele.minBiddingPrice ? ele.minBiddingPrice : '-'}`}
                    </>
                  </a>
                </Link>
              );
            } else if (
              ele.adminState &&
              ele.adminState === 'ACCEPT' &&
              ele.activeInMarketPlace &&
              ((ele.nftSaleType === 'Auctioning' &&
                ele.auctionStartTime &&
                ele.auctionEndTime &&
                Number(moment().format('x')) >= Number(ele.auctionStartTime) &&
                Number(ele.auctionEndTime) >= Number(moment().format('x'))) ||
                ele.nftSaleType !== 'Auctioning')
            ) {
              return (
                <Link
                  prefetch={false}
                  href={`/nft/${props.nftData.tokenId + '/' + ele.nftId}`}
                >
                  <a>
                    <>
                      {ele.nftSaleType === 'Auctioning'
                        ? `No ${ele.index}/${props.alllength} On auction, started at `
                        : `No ${ele.index}/${props.alllength} On sale ${
                            ele.price ? 'for ' : ''
                          }`}
                      <span>
                        {ele.price || ele.minBiddingPrice ? (
                          <span>
                            <Tooltip title="USD" classes={classes}>
                              <span className="relative">$</span>
                            </Tooltip>
                          </span>
                        ) : (
                          ''
                        )}
                        {ele.nftSaleType === 'Auctioning'
                          ? ele?.minBiddingPrice
                            ? ele.minBiddingPrice
                            : ''
                          : ele &&
                            ele.price &&
                            Number(ele.price) &&
                            countDecimals(Number(ele.price)) &&
                            countDecimals(Number(ele.price)) > 4
                          ? Number(ele.price).toFixed(4)
                          : ele && ele.price
                          ? ele.price
                          : ''}
                      </span>
                    </>

                    <br />
                  </a>
                </Link>
              );
            } else {
              return (
                <>
                  {`No ${ele.index}/${props.alllength}`}{' '}
                  {ele && ele.soldOnce ? 'Sold' : 'On sale soon'}
                  <br />
                </>
              );
            }
          })()}
        </p>
        <Link prefetch={false} href={'/collector/' + ele.userId}>
          <a>
            {ownerName && '@' + ownerName}
            <span style={{ visibility: 'hidden' }}>@</span>
          </a>
        </Link>
      </div>

      {/* Buy/Bid buttons hidden - Relysia discontinued */}
      <div className="nfticon"></div>
    </div>
  );
}
